<template>
    <div>
        <div class="header">
            <h1>Akti</h1>
            <div class="buttonsGroup">
                <button class="btn btn-outline-primary"  data-toggle="modal" data-target="#detailed-search"><i class="fas fa-search"></i> Meklētājs</button>
                <button class="btn btn-outline-primary" @click="clearFilters(1)"><i class="fas fa-times"></i> Notīrīt filtru</button>
                <button class="btn btn-primary" data-toggle="modal" data-target="#new-act" v-if="hasPermission(user,'can_access_all_acts')"><i class="fas fa-plus"></i> Pievienot jaunu aktu</button>
            </div>
        </div>
        <div class="modal fade" tabindex="-1"  id="new-act" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Jauna akta pievienošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="new_act_number">Akta numurs</label>
                                    <input type="text" v-model="new_act_number" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer text-right">
                        <button class="btn btn-primary" @click="createAct()" v-if="loading_create === false" key="create"><i class="fas fa-plus"></i> Pievienot</button>
                        <button class="btn btn-primary" v-if="loading_create === true" key="loading" disabled><i class="fas fa-spinner fa-spin"></i> Pievieno</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" tabindex="-1"  id="detailed-search" ref="vuemodal">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title">Meklētājs</h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="search_type">Meklēšanas veids</label>
                                        <select name="search_type" id="search_type" v-model="filter_search_type" class="form-control">
                                            <option value="simple">Vienkāršais</option>
                                            <option value="detailed">Detalizētais</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="act_number">Akta numurs</label>
                                        <input autocomplete="off" id="act_number" type="text" v-model="filter_act_number"  v-on:keyup.enter="search()" class="form-control">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Datums no</label>
                                        <v-date-picker
                                            :popover="{ visibility: 'click' }"
                                            @change="search()"
                                            mode="single"
                                            v-model="filter_date_from"
                                            :type="'date'"
                                            :locale="'LV'"
                                            color="teal"
                                            :masks="{
                            input: ['DD.MM.YYYY']
                        }"
                                        />
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label>Datums līdz</label>
                                        <v-date-picker
                                            :popover="{ visibility: 'click' }"
                                            @change="search()"
                                            mode="single"
                                            v-model="filter_date_to"
                                            :type="'date'"
                                            :locale="'LV'"
                                            color="teal"
                                            :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="filter_search_type=='detailed'">
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="receiver">Pieņēmējs</label>
                                        <input autocomplete="off" class="form-control" type="text" v-on:keyup.enter="search()" v-model="filter_receiver" id="receiver">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="transfer_type">Ieguves veids</label>
                                        <select class="form-control" name="transfer_type" id="transfer_type" v-model="filter_transfer_type">
                                            <option value="">Visi</option>
                                            <option v-for="transfer_type in transfer_types" :key="transfer_type.id">{{transfer_type.collection_title}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="giver">Nodevējs</label>
                                        <input autocomplete="off" class="form-control" type="text" v-on:keyup.enter="search()" v-model="filter_giver" id="giver">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="purchase_commission_decision">Pirkšanas komisijas lēmums</label>
                                        <input autocomplete="off" class="form-control" type="text" v-on:keyup.enter="search()" v-model="filter_purchase_commission_decision" id="purchase_commission_decision">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="purchase_agreement">Pirkuma līguma numurs</label>
                                        <input autocomplete="off" class="form-control" type="text" v-on:keyup.enter="search()" v-model="filter_purchase_agreement" id="purchase_agreement">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group">
                                        <label for="gift_agreement">Dāvinājuma līguma numurs</label>
                                        <input autocomplete="off" class="form-control" type="text" v-on:keyup.enter="search()" v-model="filter_gift_agreement" id="gift_agreement">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-center">
                                <button class="btn btn-primary" v-if="loading === false" @click="search()" key="search"><i class="fas fa-search"></i> Meklēt</button>
                                <button class="btn btn-primary" v-if="loading === true" key="loading"><i class="fas fa-spinner fa-spin"></i> Meklē</button>
                                <button class="btn btn-primary" v-if="loading === false"@click="clearFilters()" key="clear"><i class="fas fa-times"></i> Notīrīt filtrus</button>
                        </div>
                    </div>
                </div>
            </div>
        <div class="results">
            <div class="loader" v-if="loading">
                <img src="/images/loading.svg" alt="Loading">
            </div>
            <table class="table table-responsive-xl table-hover">
                <thead class="bg-primary text-white">
                <tr>
                    <th>Numurs</th>
                    <th>Datums</th>
                    <th>Ieguves veids</th>
                    <th>Nodevējs</th>
                    <th>Priekšmeti</th>
                    <th>Darbības</th>
                </tr>
                </thead>
                <tbody v-if="acts && loading == false">
                    <tr v-for="act in acts" :key="act.id">
                        <td><a :href="'/act/'+act.id">{{act.act_number}}</a></td>
                        <td>{{normalDate(act.date)}}</td>
                        <td><span class="badge badge-primary">{{act.transfer_type}}</span></td>
                        <td>{{act.giver}}</td>
                        <td>{{act.items_count}}</td>
                        <td><a :href="'/act/'+act.id"><span class="material-icons material-icons-outlined">edit</span></a></td>
                    </tr>
                </tbody>
            </table>
            <div v-if="acts.length === 0 && loading == false" class="alert alert-info text-center">
              Šobrīd sistēmā Jums nav pieejams neviens akts.
            </div>
            <div class="pagination" v-if="pagination.show_pagination">
                <div class="pages">
                    <div class="page" @click="search(1)" v-if="pagination.show_first_page">1</div>
                    <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
                    <div class="page" @click="search(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
                    <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
                    <div class="page" @click="search(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
                    <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
                    <div class="page" @click="search(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
                </div>
            </div>
        </div>
        <Keypress key-event="keyup" :key-code="192" @success="showSearch()" />
    </div>
</template>

<script>
export default{
    props:['transfer_types','user'],
    components: {
        Keypress: () => import('vue-keypress')
    },
    mounted()
    {
        var act_filter= localStorage.getItem('act_filter');
        var act_filter_object = JSON.parse(act_filter);
        if(act_filter_object)
        {
            this.filter_has_params = true;
            this.filter_search_type=act_filter_object.search_type;
            this.filter_items_per_page=act_filter_object.items_per_page;
            this.filter_act_number = act_filter_object.act_number;
            this.filter_date_from =  moment(act_filter_object.date_from, moment.ISO_8601)._d;
            this.filter_date_to = moment(act_filter_object.date_to, moment.ISO_8601)._d;
            this.filter_receiver = act_filter_object.receiver;
            this.filter_transfer_type = act_filter_object.transfer_type;
            this.filter_giver = act_filter_object.giver;
            this.filter_purchase_agreement = act_filter_object.purchase_agreement;
            this.filter_gift_agreement = act_filter_object.gift_agreement;
            this.filter_purchase_commission_decision = act_filter_object.purchase_commission_decision;

            this.current_page = act_filter_object.page;
        }
        else
        {
            this.filter_has_params = false;
        }

        this.search(this.current_page);
    },
    data()
    {
      return{
          acts:[],
          pagination:[],
          loading:false,
          loading_create:false,

          //Filtra vērtības
          filter_search_type:"simple",
          filter_items_per_page:15,
          filter_act_number:null,
          filter_date_from:null,
          filter_date_to:null,
          filter_receiver:null,
          filter_transfer_type:'',
          filter_giver:null,
          filter_purchase_agreement:null,
          filter_gift_agreement:null,
          filter_purchase_commission_decision:null,

          //if filterHas params
          current_page:1,
          new_act_number:"",


      }
    },
    methods:{
        hasPermission(user,permission)
        {

          return user.allpermissions.some(function(p) {
            return p.name == permission;
          });
        },
        createAct()
        {
          var that = this;
          that.loading_create = true;
          axios.post('/acts/create',{
              act_number: that.new_act_number
          }).then(response =>{
              if(response.data.status == 'ok')
              {
                  window.location.replace("/act/"+response.data.act.id);
              }

              if(response.data.status == 'error')
              {
                  that.loading_create = false;
                  that.$toast.error(response.data.message);
              }
          });

        },
        clearFilters(should_search = 0)
        {
            this.filter_items_per_page=15;
            this.filter_date_from=null;
            this.filter_date_to=null;
            this.filter_act_number=null;
            this.filter_receiver=null;
            this.filter_transfer_type='';
            this.filter_giver=null;
            this.filter_purchase_agreement=null;
            this.filter_gift_agreement=null;
            this.filter_purchase_commission_decision = null;
            localStorage.removeItem('act_filter');
            if(should_search == 1)
            {
                this.search(1);
            }
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        showSearch()
        {
            $(this.$refs.vuemodal).modal('toggle');
        },
        normalDate(date)
        {
            var d = moment(date).format('DD.MM.YYYY.');
            if(moment(d, 'DD.MM.YYYY.').isValid()) {
                return d;
            }
            else {
                return null;
            }
        },
        search(page = 1)
        {
            EventBus.$emit('enter_pressed');
            var that = this;
            this.loading = true;
            this.currentPage = page;
            if(this.filter_search_type == 'simple') {
                var filterData = {
                    act_number: that.filter_act_number,
                    date_from: that.filter_date_from,
                    date_to: that.filter_date_to,
                    search_type: that.filter_search_type,

                    page: page,
                    items_per_page: that.filter_items_per_page
                };
            }
            else{
                var filterData = {
                    act_number: that.filter_act_number,
                    date_from: that.filter_date_from,
                    date_to: that.filter_date_to,
                    receiver: that.filter_receiver,
                    transfer_type: that.filter_transfer_type,
                    giver: that.filter_giver,
                    purchase_agreement: that.filter_purchase_agreement,
                    gift_agreement: that.filter_gift_agreement,
                    purchase_commission_decision: that.filter_purchase_commission_decision,
                    search_type: that.filter_search_type,

                    page:page,
                    items_per_page: that.filter_items_per_page
                };
            }
            localStorage.setItem('act_filter', JSON.stringify(filterData));
            axios.post('/dashboard/api/acts',filterData).then(response =>{
                that.loading = false;
                if (response.data.status == 'ok')
                {
                    that.loading = false;
                    that.scrollToTop();
                    that.acts = response.data.acts;
                    that.pagination = response.data.pagination;
                    EventBus.$emit('page_updated');
                    $(that.$refs.vuemodal).modal('hide');
                }
            })
        },
    }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';
.header{
    display:flex;
    .buttonsGroup{
        margin-left:auto;
    }

}
.results{
    position:relative;
    .loader{
        cursor: progress;
        position:absolute;

        width:100%;
        height:100%;
        display:flex;
        align-items: center;
        justify-content: center;
        background:rgba(255,255,255,0.7);
        img{
            width:100px;
            height:100px;
        }

    }
}
.pagination{
    margin-top:20px;
    padding-top:20px;
    border-top:solid 2px #777;
    .pages{
        display:flex;
        margin:auto;
        .page{
            width:32px;
            height:32px;
            margin:0 10px;
            display:flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            border-radius:100%;
            font-weight: 700;
            transition: all .2s ease-in-out;
            &:hover{
                background:$blue;
                color:#fff;
            }
        }
        .delimiter{
            width:20px;
            height:32px;
            margin:0 0px;
            display:flex;
            color:#333;
            align-items: center;
            justify-content: center;
        }
        .currentPage{
            background:$blue;
            color:#fff;
            cursor:auto;
        }

    }
}
.documentFilter{
    display:flex;
    flex-wrap: wrap;
    padding:20px;
    box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.2);
    margin-bottom:10px;

    .filterBtns{
        display:flex;
        align-items: center;
        justify-content: center;
        margin-top:10px;
        .btn{
            margin:5px;
        }
    }
    .filterItem{

        padding:5px 20px;
        flex-basis:300px;
        flex-grow:1;
    }
}
</style>
